import favoritesConstants    from './favorites.constants';
import favoritesInitialState from './favorites.state';

function favoritesReducer(state = favoritesInitialState, action) {
  switch (action.type) {
    case favoritesConstants.GET_VALUE:
      state = {
        ...state,
        value: action.payload,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default favoritesReducer;
